import { Component, OnInit, ViewChild } from '@angular/core';
import { _HttpClient, ModalHelper } from '@delon/theme';
import {SFComponent, SFSchema} from '@delon/form';
import {SystemResourceEditComponent} from "./edit/edit.component";
import {NzTableComponent, NzMessageService} from 'ng-zorro-antd';
import {CacheService} from '@delon/cache';
import {AppsService, ResourceService} from "@ecip/service";
import {createContentChildren} from "@angular/compiler/src/core";

@Component({
  selector: 'app-system-resource',
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.less']
})
export class SystemResourceComponent implements OnInit {
  // url = `api/v1/sysrResource/list`;
  searchSchema: SFSchema = {
    properties: {
      id: {
        type: 'string',
        title: 'ç¼å·'
      }
    }
  };
  @ViewChild('nzTable') nzTable: NzTableComponent;

  selectId;

  data = [];
  dataList = {}; //ææèç¹çmapï¼keyä¸ºidï¼valueä¸ºèç¹å¯¹è±¡

  appList;
  appId = -1;

  constructor(public resourceService: ResourceService,
              public appsService: AppsService,
              private modal: ModalHelper,
              public msgSrv: NzMessageService,
              private cacheService: CacheService) {
  }

  ngOnInit() {
    /*this.data.forEach(item => {
      this.expandDataCache[ item.key ] = this.convertTreeToList(item);
    });
    console.log(this.expandDataCache)*/

    this.appsService.getList().subscribe(appList => {
      this.appList = appList;
    });
    this.appChange();
  }

  appChange() {
    this.resourceService.getList({appId: this.appId}).subscribe((res: any) => {
      this.data = res;
      this.data.forEach(item => {
        this.dataList[item.id] = item;
      });
    });
  }

  addChild(parentId) {
    this.selectId = parentId;
    this.add(false);
  }

  add(isRoot : boolean) {
    let parent;
    if (!isRoot) {
      if (!this.selectId) {
        this.msgSrv.warning("è¯·éæ©ç¶èç¹");
        return;
      }
      parent = this.dataList[this.selectId];
    }
    this.modal
      .createStatic(SystemResourceEditComponent, {
        i: {} , isRoot: isRoot, parent: parent, appId: this.appId})
      .subscribe((res) => {
        this.dataList[res.id] = res;
        if (isRoot) {
          this.data.push(res);
          return;
        }
        if (!parent.children) {
          parent.children = [];
          parent.expand = true;
        }
        parent.children.push(res);
      });
  }

  addpermission(item) {
    this.resourceService.addDefaultPermission(item).subscribe((res: any) =>{
      if (!item.children) {
        item.children = [];
      }
      res.forEach(it => {
        item.children.push(it);
      })
    });
  }

  edit(item) {
    this.modal
      .createStatic(SystemResourceEditComponent, { record: item })
      .subscribe((res: any) => {
        item =  Object.assign(item, res.result);
        if(res.addFlag) {
          this.resourceService.getChildren(res.result.id).subscribe((data: any) => {
            item.children = [];
            data.forEach(it => {
              item.children.push(it);
            });
          });
        }
        this.dataList[res.result.id] = item;
      });
  }

  delete(item) {
    this.resourceService.deleteById(item.id).subscribe(res => {
      this.msgSrv.success('å é¤æå');
      //æ ¹èç¹
      if (!item.pid) {
        this.data = this.data.filter(_item => _item.id !== item.id);
        this.dataList[item.id] = null;
        return;
      }
      //å­èç¹
      this.dataList[item.pid].children =
        this.dataList[item.pid].children.filter(_item => _item.id !== item.id);
    });

  }

  collapse(data: any, $event: boolean): void {
    if (!$event || data.children.length > 0) {
      return;
    }
    this.resourceService.getChildren(data.id).subscribe(res => {
      data.children = res;
      data.children.forEach(item => {
        this.dataList[item.id] = item;
      });
    });
  }
}
